import React, { Fragment, Component } from "react";
import { MDBListGroup, MDBListGroupItem } from "mdbreact";
import { connect } from "react-redux";
// import { Facebook } from "react-content-loader";
import {
  selectFeatureById,
  selectFeature
} from "~/store/features/featuresActions";
import { Link } from "react-router-dom";
import styles from "./style.module.scss";
import {
  selectHospital,
  changeBookingFlow,
  getBookingTree
} from "~/store/totalData/actions";
import { getHistoryPayment } from "~/store/fee/feeActions";
import AppId from "~/utils/partner";

class ListServiceMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: false,
      message: "Tính năng đang được cập nhật và phát triển!"
    };
  }

  toggleAlert = () => {
    this.setState(state => ({ showAlert: !state.showAlert }));
  };

  handleChooseFeature = type => {
    this.props.selectFeature(type);
  };

  renderIsAuthenticated = item => {
    if (AppId === "medpro") {
      return (
        <Link
          to="/chon-benh-vien"
          onClick={event => {
            this.props.selectFeatureById(item.id);
          }}
        >
          <div className={styles.img}>
            <img src={item.image} alt="" />
          </div>
          <p>{item.name}</p>
        </Link>
      );
    } else {
      return (
        <Link to="#" onClick={() => this.handleChooseFeature(item.type)}>
          <div className={styles.img}>
            <img src={item.image} alt="" />
          </div>
          <p>{item.name}</p>
        </Link>
      );
    }
  };

  renderServiceNotSupportYet = item => {
    return (
      <Link
        to="#"
        onClick={event => {
          event.preventDefault();
          this.toggleAlert();
        }}
      >
        <div className={styles.img}>
          <img src={item.image} alt="" />
        </div>
        <p>{item.name}</p>
      </Link>
    );
  };

  renderServicesList = () => {
    const { list = [] } = this.props;
    const serviceListNode = list.map(item => {
      if (item.status) {
        return (
          <MDBListGroupItem key={item.id}>
            {this.renderIsAuthenticated(item)}
          </MDBListGroupItem>
        );
      } else {
        return (
          <MDBListGroupItem key={item.id}>
            {this.renderServiceNotSupportYet(item)}
          </MDBListGroupItem>
        );
      }
    });
    return serviceListNode;
  };

  render() {
    return (
      <Fragment>
        <div className={styles.listService_mobile}>
          <MDBListGroup>{this.renderServicesList()}</MDBListGroup>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated },
    features: {
      allFeatures: { loading, list }
    }
  } = state;
  return {
    list,
    loading,
    IsAuthenticated
  };
};

// const mapDispatchToProps = dispatch => ({
//   requestAllFeatures: () => dispatch(featuresActions.requestAllFeatures()),
//   selectFeatureById: id => dispatch(featuresActions.selectFeatureById(id)),
//   selectHospital: id => dispatch(selectHospital(id)),
//   changeBookingFlow: flow => dispatch(changeBookingFlow(flow)),
//   getBookingTree: () => dispatch(getBookingTree())
// });

export default connect(mapStateToProps, {
  selectFeatureById,
  selectHospital,
  changeBookingFlow,
  getBookingTree,
  getHistoryPayment,
  selectFeature
})(ListServiceMobile);
